import Check from '@mui/icons-material/Check';
import Cross from '@mui/icons-material/Clear';
import * as React from 'react'

export default { Check, Cross, React }